(() => {
  if (window.MHContactChannels) return;
  const isVolumeRequest = url => ['intent', 'topic', 'type'].some(key => ['volume_quote', 'volume-quote'].includes(url.searchParams.get(key))) || url.hash.startsWith('#mh-volume-chat');
  const projectURL = url => {
    const destination = new URL((window.Shopify?.routes?.root || '/') + 'pages/contact-us', location.origin);
    ['space', 'product', 'sku', 'variant', 'quantity', 'package', 'source', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(key => {
      if (url.searchParams.has(key)) destination.searchParams.set(key, url.searchParams.get(key));
    });
    if (!destination.searchParams.has('source')) destination.searchParams.set('source', 'legacy-contact-volume-quote');
    return destination;
  };
  const currentURL = new URL(location.href);
  window.MHContactChannels = {
    openChat() {
      window.MHChatLauncher?.show();
      try {
        if (typeof window.Willdesk?.show === 'function') {
          window.Willdesk.show();
          return true;
        }
        if (document.querySelector('#__helpdesk-channel .helpdesk-channel-main-visible')) return true;
        const launcher = document.querySelector('#__helpdesk-channel .helpdesk-channel-start-btn');
        if (launcher) { launcher.click(); return true; }
      } catch { return false; }
      return false;
    }
  };
  document.addEventListener('click', async event => {
    // Only explicit chat triggers open Willdesk; plain links to /pages/contact-us navigate to the page (owner, 2026-09-23).
    const trigger = event.target.closest('[data-mh-willdesk-open]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (trigger.hasAttribute('data-mh-contact-page')) return;
    event.preventDefault();
    if (trigger.hasAttribute('data-mh-header-chat')) {
      if (trigger.getAttribute('aria-busy') === 'true') return;
      trigger.setAttribute('aria-busy', 'true');
      try {
        for (let attempt = 0; attempt < 40; attempt++) {
          if (!trigger.isConnected || window.MHContactChannels.openChat()) return;
          await new Promise(resolve => window.setTimeout(resolve, 250));
        }
      } finally {
        trigger.removeAttribute('aria-busy');
      }
    }
    if (window.MHContactChannels.openChat()) return;
    const destination = new URL(trigger.getAttribute('href') || '/pages/contact-us', location.origin);
    if (isVolumeRequest(destination)) {
      location.assign(projectURL(destination).href);
      return;
    }
    const status = document.querySelector('[data-mh-chat-status]');
    if (status) {
      status.hidden = false;
      status.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      document.querySelector('#mh-contact-name')?.focus({ preventScroll: true });
    } else {
      const fallback = new URL(trigger.getAttribute('href') || '/pages/contact-us#mh-contact-form', window.location.origin);
      if (fallback.origin !== window.location.origin || !fallback.pathname.endsWith('/pages/contact-us')) {
        fallback.href = new URL('/pages/contact-us#mh-contact-form', window.location.origin).href;
      }
      fallback.searchParams.set('chat', 'unavailable');
      window.location.assign(fallback.href);
    }
  });
  if (new URLSearchParams(window.location.search).get('chat') === 'unavailable') {
    document.querySelector('[data-mh-chat-status]')?.removeAttribute('hidden');
  }
  const params = new URLSearchParams(location.search);
  if (params.get('chat') === 'open') {
    let attempts = 0;
    const tryChat = () => {
      if (window.MHContactChannels.openChat()) return;
      if (++attempts < 30) window.setTimeout(tryChat, 500);
    };
    tryChat();
  }
})();

// Drag and dismiss controls for the asynchronously injected Willdesk launcher.
(() => {
  if (window.MHChatLauncher) return;
  const desktop = window.matchMedia('(min-width: 750px)');
  let root, position, gesture, suppressClickUntil = 0;
  let dismissed = false;
  const wrapper = () => root?.querySelector('.helpdesk-channel-btn-show');
  window.MHChatLauncher = {
    show() {
      dismissed = false;
      root?.removeAttribute('data-mh-chat-dismissed');
    }
  };

  function place(x, y) {
    const box = wrapper();
    if (!box) return;
    const rect = box.getBoundingClientRect();
    const post = box.querySelector('.helpdesk-channel-post-panel');
    const card = post?.getBoundingClientRect();
    const visible = card?.width && card.height && getComputedStyle(post).display !== 'none';
    const close = box.querySelector('[data-mh-chat-close]')?.getBoundingClientRect();
    const left = visible ? Math.min(0, card.left - rect.left) : 0;
    const top = Math.min(visible ? Math.min(0, card.top - rect.top) : 0, close ? close.top - rect.top : 0);
    const right = Math.max(visible ? Math.max(rect.width, card.right - rect.left) : rect.width, close ? close.right - rect.left : 0);
    const bottom = visible ? Math.max(rect.height, card.bottom - rect.top) : rect.height;
    const clamp = (value, min, max) => Math.max(min, Math.min(value, Math.max(min, max)));
    position = {
      x: clamp(x, 8 - left, document.documentElement.clientWidth - 8 - right),
      y: clamp(y, 8 - top, window.innerHeight - 8 - bottom)
    };
    box.style.setProperty('--mh-chat-x', `${position.x}px`);
    box.style.setProperty('--mh-chat-y', `${position.y}px`);
    box.setAttribute('data-mh-chat-positioned', '');
  }

  function enhance() {
    const box = wrapper();
    const launcher = box?.querySelector('.helpdesk-channel-start-btn');
    if (!launcher) return;
    root.toggleAttribute('data-mh-chat-dismissed', dismissed);
    if (!box.querySelector('[data-mh-chat-close]')) {
      const close = document.createElement('button');
      close.type = 'button';
      close.setAttribute('data-mh-chat-close', '');
      close.setAttribute('aria-label', 'Close chat launcher');
      close.title = 'Close chat launcher';
      close.textContent = '×';
      box.append(close);
    }
    if (position) place(position.x, position.y);
  }

  document.addEventListener('pointerdown', event => {
    if (event.button !== 0 || event.isPrimary === false) return;
    const launcher = event.target.closest('#__helpdesk-channel .helpdesk-channel-start-btn');
    if (!launcher) return;
    const box = wrapper();
    if (!box) return;
    const rect = box.getBoundingClientRect();
    gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, launcher, moved: false };
  }, true);
  document.addEventListener('pointermove', event => {
    if (!gesture || gesture.id !== event.pointerId) return;
    const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
    if (!gesture.moved && Math.hypot(dx, dy) < 6) return;
    if (!gesture.moved) {
      gesture.moved = true;
      gesture.launcher.setPointerCapture(event.pointerId);
      root.setAttribute('data-mh-chat-dragging', '');
    }
    event.preventDefault();
    place(gesture.left + dx, gesture.top + dy);
  }, { capture: true, passive: false });
  const finish = event => {
    if (!gesture || gesture.id !== event.pointerId) return;
    if (gesture.moved) suppressClickUntil = Date.now() + 500;
    if (gesture.launcher.hasPointerCapture(event.pointerId)) gesture.launcher.releasePointerCapture(event.pointerId);
    root?.removeAttribute('data-mh-chat-dragging');
    gesture = null;
  };
  document.addEventListener('pointerup', finish, true);
  document.addEventListener('pointercancel', finish, true);
  // Run before the app's document-level delegated click handler.
  window.addEventListener('click', event => {
    if (event.target.closest('#__helpdesk-channel [data-mh-chat-close]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      dismissed = true;
      root.setAttribute('data-mh-chat-dismissed', '');
    } else if (Date.now() < suppressClickUntil && event.target.closest('#__helpdesk-channel .helpdesk-channel-start-btn')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  // A keyboard equivalent to dragging; Enter/Space retain the chat action.
  document.addEventListener('keydown', event => {
    if (!event.altKey || !event.target.matches('#__helpdesk-channel .helpdesk-channel-start-btn')) return;
    const delta = { ArrowLeft: [-20, 0], ArrowRight: [20, 0], ArrowUp: [0, -20], ArrowDown: [0, 20] }[event.key];
    if (!delta) return;
    event.preventDefault();
    const box = wrapper();
    if (!box) return;
    const rect = box.getBoundingClientRect();
    place(rect.left + delta[0], rect.top + delta[1]);
  });
  window.addEventListener('resize', () => { if (position) place(position.x, position.y); });
  desktop.addEventListener('change', () => { if (position) place(position.x, position.y); });

  const findRoot = () => {
    root = document.getElementById('__helpdesk-channel');
    if (!root) return false;
    root.setAttribute('data-mh-chat-ready', '');
    enhance();
    new MutationObserver(enhance).observe(root, { childList: true, subtree: true });
    return true;
  };
  if (!findRoot()) {
    const waiting = new MutationObserver(() => { if (findRoot()) waiting.disconnect(); });
    waiting.observe(document.body, { childList: true, subtree: true });
  }
})();
